import {
  HotelLine,
  StarIcon,
  ChainIcon,
  CompassDiscoverLine,
  CruiseIcon,
  BusIcon,
  PlaneFill,
  MapPin2Line,
} from '@assets/icons';
import { WebUrlType } from '@api/index';

export const getLocationIcon = (type: string) => {
  switch (type) {
    case WebUrlType.HOTEL:
      return HotelLine;

    case WebUrlType.HOTEL_REGION:
      return MapPin2Line;

    case WebUrlType.HOTEL_CITY:
      return MapPin2Line;

    case WebUrlType.HOTEL_CHAIN:
      return ChainIcon;

    case WebUrlType.HOTEL_THEME:
      return StarIcon;

    case WebUrlType.CRUISE:
      return CruiseIcon;

    case WebUrlType.CRUISE_THEME:
      return CompassDiscoverLine;

    case WebUrlType.TOUR_COUNTRY:
      return MapPin2Line;

    case WebUrlType.CRUISE_REGION:
      return MapPin2Line;

    case WebUrlType.TOUR_THEME:
      return CompassDiscoverLine;

    case WebUrlType.TOUR_REGION:
      return MapPin2Line;

    case WebUrlType.TOUR:
      return BusIcon;

    case WebUrlType.TOUR_CITY:
    case WebUrlType.TOUR_CONTINENT:
    case WebUrlType.TAG:
      return MapPin2Line;

    case WebUrlType.VEHICLE_AIRPORT:
      return PlaneFill;

    case WebUrlType.VEHICLE_CITY:
      return MapPin2Line;

    case WebUrlType.VEHICLE_OFFICE:
      return MapPin2Line;

    case WebUrlType.FLIGHT_LANDING:
      return PlaneFill;

    case WebUrlType.FLIGHT_CITY_LANDING:
      return MapPin2Line;

    default:
      return HotelLine;
  }
};
